"use strict";
require('common/directives/paginationDirective');
require('common/directives/checkboxGroupDirective');
var urls = require('common/urls');
var editCtrl = require('user/controllers/editCtrl');
var indexCtrl = require('user/controllers/indexCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('user', ['paginationDirective', 'templates', 'checkboxGroupDirective']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', 'urls', indexCtrl]);
app.controller('editCtrl', ['$scope', '$rootScope', '$http', 'urls', 'id', 'values', 'is_admin', editCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
app.value('urls', urls);
module.exports = app;
